import { useCurrentMember as useMember } from '../../../hooks';
import { IMember } from '../definitions/member';

export const useCurrentMember = () => useMember() as IMember;